import React, { useState, useContext, useEffect } from "react";
import { TableContext } from "../../index";
import FilesDiff from "./FilesDiff";
import * as configChangesService from "./configChangesService";

// import "./styles.css";

function ConfigChangesComparison() {

    const { config } = useContext(TableContext);
    const [filesDiff, setFilesDiff] = useState(null);

    const setFilesDifferences = async () => {
        try {
            if (config && config.selected.length === 2) {
                const id1 = config.selected[0]
                const id2 = config.selected[1]
                const diffFiles = await configChangesService.getConfigChangesFilesDiff(id1, id2)
                setFilesDiff(diffFiles);
            }

        } catch (error) {
            console.error('Error:', error);
        }
    };

    useEffect(() => {
        setFilesDifferences();
        /* eslint-disable react-hooks/exhaustive-deps */
    }, [config.detectDate]);

    useEffect(() => {
        if (config && config.selected.length !== 2) {
            setFilesDiff(null);
        }
        /* eslint-disable react-hooks/exhaustive-deps */
    }, [config.selected]);

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-12">
                    <div className="oct_comparison-card-v2">
                        <h2 className="oct_comparison-title-v2">
                            Configurations Changes
                        </h2>
                        {/*upgarde commented -start 20230515 */}
                        <FilesDiff differences={filesDiff}
                            leftTitle="file#1"
                            rightTitle="file#2" />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ConfigChangesComparison;
